import { REACT_APP__URL_DATAFAN_BASE } from "@smp/utils";
import { apiRequestDatafan } from "../_helpers";
import { EApiDatafanPipelineExportType, } from "../_types";
export const ApiDatafanPipeline = {
    Export: {
        create: (req) => {
            var _a;
            const type = req.payload.type || EApiDatafanPipelineExportType.PDF;
            const config = {
                date_from: req.payload.dateFrom,
                date_to: req.payload.dateTo,
                lang: req.payload.lang,
            };
            if (type === EApiDatafanPipelineExportType.PDF) {
                config.pages = req.payload.pages
                    ? req.payload.pages.toString()
                    : undefined;
                config.extra_params = {
                    goto: {
                        timeout: 0,
                    },
                    pdf: {
                        fullPage: true,
                        width: "1280px",
                    },
                    scrollPage: false,
                    viewport: {
                        width: 1280,
                    },
                    waitFor: "#report-ready",
                };
                config.dataVisualizerInvisibleWidgets = ((_a = req.payload.invisibleWidgets) === null || _a === void 0 ? void 0 : _a.length)
                    ? req.payload.invisibleWidgets
                    : undefined;
                config.dataVisualizerSettings =
                    req.payload.settings &&
                        encodeURIComponent(JSON.stringify(req.payload.settings));
            }
            return apiRequestDatafan({
                body: {
                    _type: type,
                    config,
                    pipeline: req.path.id,
                    report_url: `${REACT_APP__URL_DATAFAN_BASE}/app/report-export/0/${req.path.id}`,
                },
                endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/pipeline/${req.path.id}/export/`,
                method: "POST",
            });
        },
        get: (req) => apiRequestDatafan({
            endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/export/${req.path.id}/`,
            method: "GET",
            query: req.query,
        }),
        getUrl: (req) => apiRequestDatafan({
            endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/export/${req.path.id}/url/`,
            method: "GET",
        }),
    },
    Mapping: {
        get: (req) => apiRequestDatafan({
            endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/pipeline/${req.path.id}/mapping/0/`,
            method: "GET",
            query: req.query,
        }),
    },
    Meta: {
        delete: (req) => apiRequestDatafan({
            endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/pipeline/${req.path.id}/meta/${req.path.sign}/`,
            method: "DELETE",
        }),
        get: (req) => apiRequestDatafan({
            endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/pipeline/${req.path.id}/meta/${req.path.sign}/`,
            method: "GET",
        }),
        post: (req) => apiRequestDatafan({
            body: req.payload,
            endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/pipeline/${req.path.id}/meta/`,
            method: "POST",
        }),
    },
    Type: {
        getList: (req) => apiRequestDatafan({
            endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/types/pipelines/`,
            method: "GET",
            query: req.query,
        }),
    },
    create: (payload, query) => apiRequestDatafan({
        body: payload,
        endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/pipeline/`,
        method: "POST",
        query,
    }),
    get: (req) => apiRequestDatafan({
        endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/pipeline/${req.path.id}/`,
        method: "GET",
        query: req.query,
    }),
    patch: (req) => apiRequestDatafan({
        body: req.payload,
        endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/pipeline/${req.path.id}/`,
        method: "PATCH",
        query: req.query,
    }),
    remove: (id) => apiRequestDatafan({
        endpoint: `${REACT_APP__URL_DATAFAN_BASE}/api/0/pipeline/${id}/`,
        method: "DELETE",
    }),
};
//# sourceMappingURL=pipeline.js.map